import React, { useState } from 'react';
import { Popover, Row, Col, Input, Button } from 'antd';
import { ReloadOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { generatePinyin } from 'shared/utils/pinyin';
import styles from './EditCharPinyin.less';

export const EditCharPinyin = ({ details, onChange, onClose }) => {
  const { char, pinyinEntry, boundingRect } = details;

  const [pinyin, setPinyin] = useState(pinyinEntry.pinyin);

  const handlePopoverClick = (e) => {
    e.stopPropagation();
  };

  const handleGeneratePinyin = async () => {
    const [pinyin] = await generatePinyin(char);
    setPinyin(pinyin);
  };

  const handleChangePinyin = (e) => {
    setPinyin(e.target.value);
  };

  const handleUpdateCharPinyin = () => {
    onChange(pinyinEntry.index, pinyin);
    onClose();
  };

  return (
    <Popover
      visible
      destroyTooltipOnHide
      overlayClassName={styles.popoverOverlay}
      title={<div onClick={handlePopoverClick}>Pinyin of {char}</div>}
      content={
        <div onClick={handlePopoverClick}>
          <Row gutter={4}>
            <Col className={styles.pinyinInputContainer}>
              <Input
                className={styles.pinyinInput}
                placeholder="Enter pinyin"
                maxLength={10}
                value={pinyin}
                onChange={handleChangePinyin}
              />

              <Button
                className={styles.generatePinyinButton}
                type="link"
                icon={<ReloadOutlined />}
                onClick={handleGeneratePinyin}
              />
            </Col>
            <Col>
              <Button type="primary" icon={<CheckOutlined />} onClick={handleUpdateCharPinyin} />
            </Col>
            <Col>
              <Button danger type="primary" icon={<CloseOutlined />} onClick={onClose} />
            </Col>
          </Row>
        </div>
      }
    >
      <div
        className={styles.editCharPinyinPlaceholder}
        style={{
          left: boundingRect.left,
          top: boundingRect.top,
          width: boundingRect.width,
          height: boundingRect.height,
        }}
      />
    </Popover>
  );
};

EditCharPinyin.propTypes = {
  details: PropTypes.shape({
    char: PropTypes.string.isRequired,
    pinyinEntry: PropTypes.shape({
      index: PropTypes.number.isRequired,
      span: PropTypes.number.isRequired,
      pinyin: PropTypes.string,
    }).isRequired,
    boundingRect: PropTypes.shape({
      left: PropTypes.number.isRequired,
      top: PropTypes.number.isRequired,
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
